const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_shree-3d-events/artifacts/c3s56qep_Shree-events-11-Final-Horizontal-600.png";

export default function Footer() {
  return (
    <footer className="relative border-t border-white/5 mt-10 z-10" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-12 flex flex-col md:flex-row items-center justify-between gap-8">
        <a href="#top" className="flex items-center" data-testid="footer-logo-link">
          <span className="relative inline-flex p-3 rounded-2xl bg-gradient-to-br from-gold/[0.12] to-transparent border border-gold/15 shadow-[0_4px_24px_rgba(212,175,55,0.18)]">
            <img
              src={LOGO_URL}
              alt="Shree Event Planner"
              className="h-14 w-auto object-contain drop-shadow-[0_2px_12px_rgba(212,175,55,0.4)]"
              data-testid="footer-logo"
            />
          </span>
        </a>

        <p className="text-ivory/55 text-xs tracking-wider text-center" data-testid="footer-copyright">
          © {new Date().getFullYear()} Shree Event Planner ·{" "}
          <span>Designed by </span>
          <a
            href="https://www.automizeon.co.uk/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gold hover:text-gold-glow underline-offset-4 hover:underline transition-colors"
            data-testid="footer-automizeon-link"
          >
            Automizeon
          </a>
        </p>

        <div className="flex items-center gap-5 text-ivory/55 text-xs uppercase tracking-[0.2em]">
          <a href="#about" className="hover:text-gold transition-colors">About</a>
          <a href="#services" className="hover:text-gold transition-colors">Services</a>
          <a href="#contact" className="hover:text-gold transition-colors">Contact</a>
        </div>
      </div>
    </footer>
  );
}
